import React from 'react';

import styles from './ExpandedFilters.module.css';
import { BookingTypeField } from '../BookingType/BookingTypeField';
import { DateSelector } from '../DateSelector/DateSelector';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { LocationField } from '../Location/LocationField';
import { ServiceTypeField } from '../ServiceType/ServiceTypeField';
import { YourPetsField } from '../YourPets/YourPetsField';

import type { ReactElement } from 'react';

const ExpandedFilters = (): ReactElement => (
  <div className={styles.root}>
    <section>
      <ErrorBoundary fieldName="service">
        <div className={styles.serviceFields}>
          <ServiceTypeField />
          <BookingTypeField />
        </div>
      </ErrorBoundary>

      {/* We are passing in unique names and labels into the components below to
      mitigate pipeline errors and accessibility issues with having multiple
      inputs using the same values. */}

      <ErrorBoundary fieldName="chronology">
        <DateSelector
          dateFormat="fancy"
          isCalendarIconHidden={false}
          name="searchDates"
          nameFrom="searchDateFrom"
          nameTo="searchDateTo"
        />
      </ErrorBoundary>

      <ErrorBoundary fieldName="location">
        <LocationField
          isMaxWithEnabled
          label="Near"
          name="searchLocation"
          placeholder="Search location"
        />
      </ErrorBoundary>

      <ErrorBoundary fieldName="petTypes">
        <YourPetsField legend="Add your pets" />
      </ErrorBoundary>
    </section>
  </div>
);

export { ExpandedFilters };
